import React, { Component } from "react";
import { connect } from "react-redux";
import { intersection } from "lodash";

const Authorize = (allowedRoles, ForbiddenPage) => Page => {
  class Container extends Component {
    render() {
      const {
        auth: { user },
        ...props
      } = this.props;
      const roles = user?.roles || [];
      if (intersection(allowedRoles, roles).length > 0) {
        return <Page {...props} />;
      }
      return <ForbiddenPage />;
    }
  }
  return connect(state => ({
    auth: state.auth,
  }))(Container);
};

export default Authorize;
